var _g, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDiamondBoxHome(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "uuid-9454c105-ab11-4342-8836-a592878a1070",
    "data-name": "uuid-8788c5d3-7126-465f-b95b-5d780c01ad61",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 210.44433 194.86055",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "uuid-90c3d24b-8c94-461a-92c3-597d3dbf11a7",
    "data-name": "uuid-c7956a33-ea79-4b5b-ad19-331d2c8df04a"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 38.32753,
    y: 30.53667,
    width: 133.78722,
    height: 133.78721,
    transform: "translate(-38.07505 102.93925) rotate(-45)",
    fill: "none",
    stroke: "#ffd58c",
    strokeMiterlimit: 10,
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "163.8453 124.2321 190.64531 97.4321 163.8453 70.6321 132.00531 38.8021 114.39531 21.1921 96.04531 21.1921 78.43531 38.8021 46.59531 70.6321 19.79531 97.4321 46.59531 124.2321 78.42531 156.05209 96.04531 173.6721 114.39531 173.6721 132.0153 156.05209 163.8453 124.2321",
    fill: "none",
    stroke: "#ffd58c",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "46.59531 135.0587 46.59531 156.05209 67.5953 156.05209",
    fill: "none",
    stroke: "#ffd58c",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "67.5953 38.8021 46.59531 38.8021 46.59531 59.7955",
    fill: "none",
    stroke: "#ffd58c",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "163.8775 59.7312 163.8775 38.7378 142.8775 38.7378",
    fill: "none",
    stroke: "#ffd58c",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "163.84541 135.0587 163.84541 156.05209 142.84541 156.05209 163.84541 135.0587",
    fill: "none",
    stroke: "#ffd58c",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 193.3377,
    y: 90.9321,
    width: 13.00002,
    height: 13.00002,
    transform: "translate(-10.36379 169.8438) rotate(-45)",
    fill: "none",
    stroke: "#ffd58c",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4.10661,
    y: 90.90969,
    width: 13.00002,
    height: 13.00002,
    transform: "translate(-65.77246 36.03065) rotate(-45)",
    fill: "none",
    stroke: "#ffd58c",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M59.65324,97.41324c.37235-.44815,.6857-.96698,1.12562-1.33417,13.18279-11.0035,26.37608-21.99443,39.57288-32.98113,3.16633-2.63606,6.58151-2.6273,9.75088,.01439,4.12349,3.43695,8.23722,6.88561,12.35618,10.32801,.2237,.18696,.45676,.36271,.81099,.643,.02188-.41056,.04919-.68755,.04946-.96457,.0031-3.14425-.00246-6.28851,.0039-9.43275,.00364-1.79986,.59093-2.37734,2.40962-2.37972,3.23324-.00423,6.46649-.00616,9.69972,.00096,1.73119,.00381,2.3522,.63173,2.35292,2.36968,.00299,7.20805,.01132,14.41614-.01529,21.62408-.00246,.66605,.20741,1.07958,.71065,1.49314,3.71179,3.05033,7.39961,6.12982,11.0961,9.1988,1.50491,1.24944,1.58957,2.10402,.34916,3.58478-.91414,1.09127-1.82187,2.188-2.74388,3.27257-1.02359,1.20405-1.99849,1.28919-3.21518,.27503-12.52964-10.44396-25.05699-20.89065-37.58522-31.3363-.36295-.30261-.72839-.60222-1.16249-.96092-1.41989,1.1804-2.82854,2.34848-4.23403,3.52035-11.48037,9.57207-22.9598,19.14527-34.4406,28.71684-1.30884,1.09118-2.26034,1.01431-3.34463-.28449-1.19065-1.42619-2.36519-2.86584-3.54675-4.29962v-1.06796h0Z",
    fill: "#f9d089"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M112.48192,133.62669v-21.58191h-14.50431v21.64475c-.44434,0-.76319,0-1.08204,0-6.6436-.00002-13.2872,.00147-19.93081-.00073-2.8927-.00096-4.31168-1.4225-4.31204-4.31539-.00108-8.60109,.00371-17.20219-.00924-25.80326-.0009-.59891,.11372-1.03807,.61894-1.45325,10.40096-8.54743,20.78457-17.11596,31.1727-25.67899,.24773-.2042,.50782-.3934,.8054-.62296,2.3351,1.92259,4.64418,3.82172,6.95107,5.72351,8.3055,6.84702,16.60714,13.69875,24.92335,20.53273,.47995,.39441,.6859,.7943,.68454,1.42179-.01889,8.74935-.00774,17.49875-.01637,26.24812-.00234,2.3783-1.50372,3.93145-3.87446,3.9394-6.94012,.02326-13.88035,.00862-20.82054,.00602-.17117-.00007-.34234-.03284-.60618-.05983h0Z",
    fill: "#f9d089"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiamondBoxHome);
export default __webpack_public_path__ + "static/media/diamond-box-home.7df4d3ae14f25a9326be3f3ca0417ae6.svg";
export { ForwardRef as ReactComponent };